import type { Translations } from "./en";

export const fr: Translations = {
	locale: "fr",
	seo: {
		homeTitle: "Développeur logiciel freelance web et mobile",
		homeDescription:
			"Simon Boisset, développeur logiciel freelance basé à Nantes : applications web et mobiles en TypeScript, React, React Native et Node.js. Renfort d’équipe, reprise d’application, migration Expo. En télétravail avec des équipes en France et à l’international.",
		expoMigrationTitle: "Migration React Native vers Expo",
		expoMigrationDescription:
			"Migrer une application React Native legacy vers Expo sans bloquer les releases : signaux d’alerte, risques couverts, méthode en quatre étapes, retours clients et FAQ.",
		questoveryTitle: "Questovery : jeux de piste géolocalisés",
		questoveryDescription:
			"Questovery, le produit que je conçois, développe et vends seul : jeux de piste, chasses au trésor et visites guidées, avec un espace web et une app iOS et Android.",
		aboutTitle: "Parcours : du laser au code",
		aboutDescription:
			"Physicien de formation, cinq ans dans l’industrie laser, puis développement logiciel depuis 2020 : startups, missions freelance et produits personnels.",
		blogTitle: "Blog",
		cvTitle: "CV",
		cvDescription:
			"CV de Simon Boisset, développeur logiciel freelance web et mobile : missions, produits, compétences et formation. Version PDF disponible.",
	},
	nav: {
		brand: "Simon Boisset",
		home: "Accueil",
		expoMigration: "Migration Expo",
		questovery: "Questovery",
		about: "Parcours",
		blog: "Blog",
		cv: "CV",
		bookCall: "Réserver un échange",
		menu: "Menu",
		skip: "Aller au contenu",
	},
	footer: {
		description:
			"Développeur logiciel freelance, web et mobile. Applications TypeScript, du premier build à la prochaine release.",
		site: "Site",
		contact: "Contact",
		legal: "Légal",
		scheduleCall: "Réserver un échange",
		blog: "Blog",
		docs: "Documents légaux",
		legalNotice: "Mentions légales",
		privacy: "Confidentialité",
		withdrawConsent: "Retirer mon accord analytics",
		manageConsent: "Gérer les analytics",
		github: "GitHub",
		linkedin: "LinkedIn",
		cvPdf: "CV (PDF)",
	},
	common: {
		bookCall: "Réserver un échange",
		sendEmail: "Écrire un e-mail",
		downloadCv: "Télécharger le CV (PDF)",
		example: "Exemple",
		visit: "Visiter",
	},
	consent: {
		title: "Mesure d’audience",
		description:
			"Avec votre accord, PostHog mesure les pages consultées, la provenance et les clics vers Cal.com ou l’e-mail. Aucun enregistrement de session ni capture automatique des interactions.",
		retention:
			"Votre choix est mémorisé six mois. Vous pouvez le modifier à tout moment depuis « Gérer les analytics » en bas de page.",
		policyLink: "Voir la politique de confidentialité",
		accept: "Accepter",
		deny: "Refuser",
		close: "Fermer",
	},
	notFound: {
		label: "Erreur 404",
		title: "Cette page s'est égarée.",
		description: "La page que vous cherchez n'existe pas ou a été déplacée.",
		backHome: "Retour à l'accueil",
	},
	blog: {
		heroLabel: "Blog",
		heroTitle: "Notes de terrain React Native et Expo.",
		description:
			"Retours pratiques sur les migrations, les circuits de livraison, l'architecture mobile et les choix produit derrière Questovery.",
		featured: "À la une",
		latest: "Derniers articles",
		empty: "Aucun article publié pour le moment.",
		back: "Retour au blog",
		other: "Autres articles",
		bookCtaButton: "Réserver un échange",
		errorTitleList: "Erreur lors du chargement du blog",
		errorTitleDetail: "Erreur lors du chargement de l'article",
		errorFallback: "Une erreur inattendue s'est produite",
	},
	docs: {
		heroLabel: "Documents",
		heroTitle: "Documentation légale",
		heroDescription:
			"Retrouvez les documents obligatoires et informations légales.",
		effectiveDate: "Date d'effet",
		empty: "Aucun document disponible.",
		cardDescriptions: {
			legal: "Éditeur, hébergement et contacts.",
			privacy: "Collecte des données et vos droits.",
		},
	},
	scenes: {
		prism: {
			era: "2014 – 2020",
			title: "Physique des lasers",
			subtitle: "Master Lille 1 · Amplitude Laser",
			pivot: "2020",
			rays: {
				product: { label: "Produit", value: "UX/UI, marketing, vente" },
				ai: { label: "IA agentique", value: "Claude Code · Codex · MCP" },
				backend: { label: "Back-end", value: "Node.js · oRPC · PostgreSQL" },
				web: { label: "Web", value: "React · TanStack Start" },
				mobile: { label: "Mobile", value: "React Native · Expo" },
			},
		},
		migration: {
			before: "Avant · RN legacy",
			after: "Après · Expo",
			arrow: "migration",
			pipeline: "Pipeline de release",
			build: "build",
			release: "release",
			stores: "stores",
		},
		questovery: {
			step: "Étape 3 / 5",
			points: "240 pts",
			title: "Le vieux lavoir",
			scan: "Scannez le QR code de l’étape",
			validate: "Valider l’étape",
			team: "Équipe 4",
		},
		chaban: {
			status: "Pont levé",
			app: "Mon Pont Chaban",
			time: "21:12",
			title: "Fermeture à 21:30",
			body: "Pont levé jusqu’à 23:10, prévoyez un détour",
		},
	},
	home: {
		hero: {
			title: "Développeur logiciel freelance, web et mobile",
			titleLead: "Développeur logiciel freelance,",
			titleMark: "web & mobile",
			intro:
				"Je conçois et développe des applications web et mobiles en TypeScript, de l’interface à l’API, jusqu’à la mise en production. Depuis 2020, pour des startups et des PME, en renfort d’équipe ou en lead technique, avec React, React Native et Node.js.",
			ctaPrimary: "Réserver un échange",
			ctaSecondary: "Voir mon parcours",
			proofs: {
				since: "En production depuis 2020",
				platforms: "Web · iOS · Android",
				stack: "TypeScript de bout en bout",
			},
		},
		contacts: {
			email: "email",
			site: "site",
			linkedin: "linkedin",
			github: "github",
			location: "lieu",
			locationValue: "Nantes, télétravail",
		},
		services: {
			title: "Ce que je fais",
			subtitle: "en mission",
			team: {
				title: "Renfort d’équipe",
				description:
					"Livrer les prochaines fonctionnalités avec votre équipe : web, mobile et API, jusqu’à la mise en production.",
			},
			takeover: {
				title: "Reprise d’une application",
				description:
					"Comprendre vite une base de code existante, dégager les priorités techniques, remettre de la structure là où il en faut.",
			},
			creation: {
				title: "Création d’application",
				description:
					"Concevoir et livrer une app web ou mobile de zéro, alignée avec votre produit existant.",
			},
			lead: {
				title: "Lead technique",
				description:
					"Faire évoluer l’architecture et accompagner l’équipe dans ses choix techniques.",
			},
		},
		profile: {
			title: "Profil",
			specialty: {
				label: "Spécialité",
				value:
					"Applications web et mobiles en TypeScript : React, React Native, Node.js, de la conception à la production.",
			},
			production: {
				label: "Production",
				value:
					"Pipelines de build, publication sur les stores, maintenance d’apps en production.",
			},
			product: {
				label: "Produit",
				value:
					"Deux produits conçus, lancés et exploités seul, de l’interface jusqu’à la vente.",
			},
			training: {
				label: "Formation",
				value:
					"Master en physique des lasers, puis cinq ans dans l’industrie laser.",
			},
		},
		journey: {
			title: "Mon parcours",
			subtitle: "d’un coup d’œil",
			lanes: {
				laser: "Laser",
				code: "Code",
				products: "Produits",
				around: "Autour",
			},
			bars: {
				master: "Master",
				amplitude: "Amplitude Laser · industrie laser",
				selfTaught: "autodidacte, en parallèle",
				silbo: "Silbo · CDI full-stack",
				linote: "LiNote",
				vaerdict: "VAERDICT",
				ccp: "CAMPING-CAR PARK",
				mobiapps: "MOBIAPPS",
				chaban: "Mon Pont Chaban",
				questovery: "Questovery",
				around: "IA · marketing · vente",
			},
			today: "aujourd’hui",
		},
		missions: {
			title: "Ce que j’ai livré",
			subtitle: "contexte · action · résultat",
			labels: {
				context: "contexte",
				action: "action",
				result: "résultat",
			},
			ccp: {
				company: "CAMPING-CAR PARK",
				period: "03.2024 – 09.2025",
				role: "React Native · référent mobile",
				stack: "Expo · CI/CD · cartographie",
				context:
					"Application de réservation en production, sur un socle React Native vieillissant.",
				action:
					"Migration vers Expo : librairies non maintenues remplacées, pipeline de build et de release configurée. Puis refonte en 2025, réservation et cartographie, avec les équipes produit et backend.",
				result:
					"Un socle Expo à jour, des releases fiabilisées et une équipe accompagnée sur la durée.",
			},
			mobiapps: {
				company: "MOBIAPPS",
				period: "10.2025",
				role: "React Native · migration Expo",
				stack: "Expo · config plugins",
				context: "Application React Native legacy à moderniser.",
				action:
					"Migration vers Expo : configuration native, plugins Expo, dépendances et React Navigation.",
			},
			vaerdict: {
				company: "VAERDICT",
				period: "depuis 2024",
				role: "Full-stack · lead technique",
				stack: "React · Node.js · TypeScript",
				context:
					"Application web métier à faire évoluer, avec une équipe interne.",
				action:
					"Re-architecture pour gagner en évolutivité, lead technique de l’équipe.",
				result: "Une base plus évolutive, une équipe accompagnée.",
			},
			linote: {
				company: "LiNote",
				period: "2023",
				role: "React Native · création",
				stack: "Expo · iOS · Android",
				context: "Plateforme de communication web, sans application mobile.",
				action:
					"App créée de zéro : messagerie, envoi de photos, appels visio, notifications et alertes.",
				result: "Fonctionnalités clés livrées sur iOS et Android.",
			},
			silbo: {
				company: "Silbo",
				period: "2020 – 2022 · CDI",
				role: "Full-stack",
				stack: "Node.js · TypeScript · React · React Native",
				context: "Applications web et terrain pour la santé.",
				action:
					"Développement full-stack, temps réel, exploitation en production.",
				result: "Applications livrées et utilisées au quotidien.",
			},
		},
		testimonialsSection: {
			title: "Retours clients",
			subtitle: "après mission",
		},
		testimonials: {
			eric: {
				name: "Eric",
				quote:
					"Nous partions d'un legacy assez complexe. Simon a repris le projet, remis de l'ordre dans toute la stack et continue de nous accompagner au quotidien.",
			},
			julie: {
				name: "Julie",
				quote:
					"Simon a construit notre app React Native depuis zéro, en restant aligné avec l'app web. En quelques semaines, nous avions les rappels, les messages, le partage de photos et les appels vidéo.",
			},
			matthieu: {
				name: "Matthieu",
				quote:
					"Nous traînions cette migration Expo depuis plus d'un an. Simon nous a rassurés, l'a livrée en deux semaines, et nous avons pu publier une version propre derrière.",
			},
			thomas: {
				name: "Thomas",
				quote:
					"Simon est arrivé sur un projet où le front, le backend, le mobile et l'infra étaient tous liés. Il a vite compris comment tout s'emboîtait, ce qui nous a évité beaucoup d'allers-retours.",
			},
			romuald: {
				name: "Romuald",
				quote:
					"Simon a migré vers Expo trois de nos apps React Native maintenues depuis plus de 9 ans. La migration s'est faite en douceur, et nous en mesurons déjà les bénéfices : montées de version bien plus rapides, builds enfin fiables.",
			},
			antoine: {
				name: "Antoine",
				quote:
					"Notre codebase mobile était devenue trop complexe : trop de cas particuliers, trop de dépendances, plus beaucoup de certitudes. Simon nous a aidés à reprendre la maîtrise et à remettre une structure claire.",
			},
		},
		focus: {
			title: "Une expertise, un produit",
			subtitle: "chacun sa page",
			migration: {
				meta: "expertise",
				name: "Migration React Native → Expo",
				lede: "Passer une app React Native legacy sur Expo sans bloquer les releases, y compris des apps maintenues depuis plus de neuf ans.",
				link: "Voir la migration Expo",
			},
			questovery: {
				meta: "mon produit · depuis 2024",
				name: "Questovery",
				lede: "Jeux de piste, chasses au trésor et visites guidées : un espace web pour les organisateurs, une app iOS et Android pour les joueurs. Conçu, développé et vendu seul.",
				link: "Découvrir Questovery",
			},
		},
		products: {
			title: "Produits",
			subtitle: "conçus, développés et exploités seul",
			questovery: {
				meta: "depuis 2024 · fondateur",
				name: "Questovery",
				lede: "Jeux de piste géolocalisés : un espace web pour les organisateurs, une app iOS et Android pour les équipes.",
				points: {
					offline: "Hors-ligne et synchronisation, GPS, QR codes, médias.",
					ai: "IA agentique pour accélérer le développement.",
					sales: "Marketing et vente du produit.",
				},
				stack: "TanStack Start · oRPC · React · React Native · Expo",
				link: "questovery.com",
			},
			chaban: {
				meta: "depuis 2022",
				name: "Mon Pont Chaban",
				lede: "Les levées du pont Chaban-Delmas à Bordeaux : statut en direct et alertes personnalisées.",
				points: {
					alerts:
						"Push et email réglables par jour et par heure, calendrier iCal.",
					effect: "Back-end Effect TS, données Bordeaux Métropole.",
					stack: "Web, iOS et Android sur un même socle TypeScript.",
				},
				stack: "même stack que Questovery · Effect TS",
				link: "pont-chaban-delmas.com",
			},
		},
		skills: {
			title: "Compétences",
			mobile: {
				title: "Mobile",
				items:
					"React Native, Expo, EAS, notifications push, géolocalisation, publication sur les stores",
			},
			web: { title: "Web", items: "TypeScript, React, TanStack Start" },
			backend: {
				title: "Back-end & livraison",
				items:
					"Node.js, oRPC, Effect TS, Bun, PostgreSQL, Drizzle, Docker, GitHub Actions, CI/CD",
			},
			ai: { title: "IA agentique", items: "Claude Code, Codex, MCP" },
			product: {
				title: "Produit",
				items: "UX/UI, parcours utilisateurs, marketing, vente",
			},
			educationLabel: "Formation",
			master: "Master Physique des lasers",
			masterDetail: "Université Lille 1, 2014",
			selfTaught: "Développement logiciel",
			selfTaughtDetail: "autodidacte, par projets, depuis 2015",
		},
		contact: {
			title: "Contact",
			body: "J’aime arriver sur un produit existant, comprendre ses contraintes et le faire avancer avec l’équipe en place. Si votre application web ou mobile a besoin de renfort, je serai ravi d’en discuter.",
		},
	},
	expoMigration: {
		hero: {
			kicker: "Migration Expo",
			title: "Migrer une app React Native vers Expo, sans bloquer les releases",
			intro:
				"Je passe les applications React Native legacy sur Expo pendant que le produit continue d’avancer. Votre équipe repart avec un circuit de build et de publication qu’elle maîtrise.",
		},
		signs: {
			title: "Quand migrer",
			subtitle: "les signaux qui reviennent",
			upgrades: {
				title: "Les montées de version font peur",
				description:
					"Chaque mise à jour de React Native ou des SDK des stores devient un chantier.",
			},
			builds: {
				title: "Les builds cassent",
				description:
					"Les builds iOS et Android échouent sans raison claire, et peu de personnes savent les réparer.",
			},
			libraries: {
				title: "Des librairies natives abandonnées",
				description:
					"Des dépendances ne sont plus maintenues et bloquent chaque mise à jour.",
			},
			stalled: {
				title: "La migration traîne",
				description:
					"Le passage à Expo est prévu depuis des mois, sans jamais trouver le bon moment.",
			},
		},
		risks: {
			title: "Ce que je sécurise pendant une migration",
			subtitle: "là où les migrations bloquent",
			native: {
				title: "Surface native",
				description:
					"Dépendances, permissions, config plugins, prebuild et modules qui peuvent bloquer Expo.",
				bullet:
					"Vous obtenez une carte de compatibilité et des options claires de remplacement ou de repli.",
			},
			delivery: {
				title: "Déploiements EAS et QA",
				description:
					"EAS Build, Submit, Update, channels, CI et distribution QA.",
				bullet:
					"Vous repartez avec des builds EAS automatisés, des canaux de test et des mises à jour OTA que votre équipe déclenche seule.",
			},
			tailored: {
				title: "Choix sur mesure",
				description:
					"Arbitrages selon votre stack, vos contraintes stores et votre cadence produit.",
				bullet:
					"Nous choisissons ensemble les options Expo utiles, sans workflow générique.",
			},
			handoff: {
				title: "Autonomie de l’équipe",
				description:
					"Décisions, playbooks et arbitrages sont écrits pour l’équipe interne.",
				bullet:
					"La migration se termine avec un workflow que votre équipe opère sans moi.",
			},
		},
		method: {
			title: "Comment se déroule une migration",
			subtitle: "quatre étapes",
			steps: {
				map: {
					label: "cartographier",
					title: "Comprendre l’existant",
					description:
						"Code, dépendances natives, CI et parcours critiques passés en revue avant de toucher au code.",
					outcome: "Priorités et ordre de traitement",
				},
				migrate: {
					label: "migrer",
					title: "Moderniser sans bloquer",
					description:
						"Migration Expo quand elle sert le besoin, librairies incompatibles remplacées, builds sécurisés.",
					outcome: "Une app qui build proprement",
				},
				prove: {
					label: "livrer",
					title: "Livrer pour de vrai",
					description:
						"Versions de test régulières, parcours vérifiés sur iOS et Android, publication sur les stores.",
					outcome: "Un chemin de release éprouvé",
				},
				transfer: {
					label: "transmettre",
					title: "Rendre l’équipe autonome",
					description:
						"Commandes, décisions et options de repli documentées pour la maintenance.",
					outcome: "Une équipe prête pour les prochaines releases",
				},
			},
		},
		testimonialsTitle: "Ils en parlent",
		faq: {
			title: "Questions fréquentes",
			duration: {
				question: "Combien de temps dure une migration Expo ?",
				answer:
					"Cela dépend des dépendances natives, de la CI et du circuit de release. Une migration ciblée peut se faire en deux semaines ; plusieurs apps anciennes demandent plus. La revue initiale permet d’estimer le périmètre avant toute modification.",
			},
			releases: {
				question: "Faut-il arrêter les releases pendant la migration ?",
				answer:
					"Non. L’objectif est de migrer pendant que le produit continue d’avancer, puis de prouver le nouveau chemin de release sur une version que l’équipe peut inspecter.",
			},
			after: {
				question: "Pouvez-vous rester après la migration ?",
				answer:
					"Oui. Je peux continuer à accompagner l’équipe sur les évolutions, les publications et le suivi technique.",
			},
			remote: {
				question: "Travaillez-vous à distance ?",
				answer:
					"Oui, en télétravail depuis Nantes, avec des équipes en France et à l’international.",
			},
		},
	},
	questovery: {
		hero: {
			kicker: "Questovery",
			title: "Questovery, mon produit de jeux de piste",
			intro:
				"Questovery permet de concevoir, lancer et piloter des jeux de piste, chasses au trésor et visites guidées. Je le conçois, le développe, l’exploite et le vends seul depuis 2024.",
		},
		roleLabel: "Mon rôle",
		stackLabel: "Stack",
		featuresLabel: "Ce que fait le produit",
		product: {
			title: "Le produit",
			meta: "depuis 2024 · fondateur",
			lede: "Créer et animer des jeux de piste. Les organisateurs préparent leurs parcours et suivent les équipes depuis un espace web, les participants jouent sur une app iOS et Android.",
			role: "Conception produit, UX/UI, développement full-stack et mobile, déploiement, maintenance, marketing et vente.",
			features: {
				app: "App mobile : parcours de jeu, géolocalisation, QR codes, caméra et médias, avec les permissions du téléphone prises en charge.",
				web: "Espace web : création des parcours, configuration des étapes, gestion des équipes, suivi en direct et résultats.",
				offline:
					"Contraintes du terrain : actions de jeu conservées localement puis synchronisées, sans double comptage, reprise après une coupure.",
				ops: "Builds mobiles, déploiements web et serveur, suivi des erreurs, tests sur les règles de jeu, les droits d’accès et la synchronisation.",
			},
			stack:
				"TanStack Start · oRPC · React · React Native · Expo · PostgreSQL · Drizzle",
			link: "questovery.com",
		},
		uses: {
			title: "Pour qui",
			subtitle: "quelques usages",
			teamBuilding: {
				title: "Team building",
				description:
					"Des défis en équipe pour les séminaires et événements d’entreprise.",
			},
			tours: {
				title: "Visites guidées",
				description:
					"Des parcours de découverte d’une ville ou d’un lieu, à suivre sur le téléphone.",
			},
			parties: {
				title: "Anniversaires et fêtes",
				description:
					"Des chasses au trésor prêtes à jouer pour un anniversaire ou une fête.",
			},
		},
		lessons: {
			title: "Ce que j’en rapporte en mission",
			subtitle: "de l’autre côté du comptoir",
			production: {
				title: "La production, pour de vrai",
				description:
					"Je publie et maintiens mes propres apps : stores, mises à jour, suivi des erreurs. Je sais ce que coûte une release ratée.",
			},
			product: {
				title: "Le regard produit",
				description:
					"Je fais des choix d’interface, de prix, de marketing et de vente, pas seulement des choix techniques.",
			},
			ai: {
				title: "L’IA agentique au quotidien",
				description:
					"Claude Code, Codex et MCP sur une base de code qui tourne en production, avec la relecture que ça demande.",
			},
		},
	},
	about: {
		hero: {
			kicker: "Parcours",
			title: "Du laser au code",
			intro:
				"Physicien de formation, j’ai travaillé cinq ans dans l’industrie laser avant de faire du développement logiciel mon métier.",
		},
		story: {
			title: "Le parcours",
			laser: {
				period: "2014 – 2020",
				title: "Physique et lasers",
				body: "Master en physique des lasers à l’Université Lille 1, puis cinq ans chez Amplitude Laser. Optique, photonique, modélisation mathématique : une rigueur scientifique que j’applique toujours au code.",
			},
			code: {
				period: "2015 – 2020",
				title: "Le code en autodidacte",
				body: "En parallèle, j’apprends le développement par projets : le web et le produit d’abord, puis l’architecture mobile, le DevOps et le full-stack.",
			},
			startups: {
				period: "2020 – 2022",
				title: "Premier poste en startup",
				body: "Développeur full-stack chez Silbo, applications web et terrain pour la santé, temps réel et exploitation en production.",
			},
			freelance: {
				period: "depuis 2023",
				title: "Freelance",
				body: "Missions React Native et full-stack pour des startups et des PME : LiNote, VAERDICT, CAMPING-CAR PARK, MOBIAPPS.",
			},
			products: {
				period: "depuis 2022",
				title: "Mes propres produits",
				body: "Mon Pont Chaban, puis Questovery. Les construire m’a appris le produit, le marketing et la vente, et l’usage de l’IA agentique sur du code qui tourne en production.",
			},
		},
		ai: {
			title: "L’IA dans mon travail",
			body: "Usage quotidien, sur des produits en production.",
			tools: "Claude Code · Codex · MCP",
		},
	},
	cv: {
		pageLabel: "CV",
		download: "Télécharger le PDF",
		print: "Imprimer",
		header: {
			name: "Simon Boisset",
			intro:
				"Physicien de formation, j’ai travaillé cinq ans dans l’industrie laser avant de faire du développement logiciel mon métier. Depuis 2020, je l’exerce professionnellement, d’abord au sein de startups, puis en freelance pour des startups et des PME, sur des applications web et mobiles. En parallèle, je développe mes propres produits.",
			location: "Nantes, télétravail",
		},
	},
};
